import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../Header';
import BottomNavigationBar from '../BottomNavigationBar';
import ForumList from './ForumList';
import AdminForumList from './Admin/AdminForumList';
import './ForumPage.css';

const ForumPage = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="App">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '18px',
          color: '#666'
        }}>
          Loading...
        </div>
      </div>
    );
  }

  // Forums are now publicly viewable - no authentication required
  // Authentication is only required for actions (reply, vote, create)

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleCategoriesClick = () => {
    navigate('/categories');
  };

  const handleHowItWorksClick = () => {
    navigate('/#how-it-works');
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleAccountSettingsClick = () => {
    navigate('/settings');
  };

  const handleForumClick = () => {
    navigate('/forum');
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSignupClick = () => {
    navigate('/signup');
  };

  const handleJobsClick = () => {
    navigate('/vacancies');
  };

  const handleMessagesClick = () => {
    navigate('/messages');
  };

  // Check if user is admin (customize this based on your admin system)
  // Only check if user is authenticated
  const isAdmin = isAuthenticated && (user?.role === 'admin' || user?.is_admin === true);

  return (
    <div className="App forum-with-bottom-nav">
      <div className="forum-header">
        <Header 
          onLoginClick={handleLoginClick}
          onSignupClick={handleSignupClick}
          isLoggedIn={isAuthenticated}
          user={user}
          onHomeClick={handleHomeClick}
          onCategoriesClick={handleCategoriesClick}
          onHowItWorksClick={handleHowItWorksClick}
          onProfileClick={handleProfileClick}
          onAccountSettingsClick={handleAccountSettingsClick}
          onForumClick={handleForumClick}
          currentPage="forum"
        />
      </div>
      <div className="forum-module">
        <div className="forum-page">
          {isAdmin ? (
            <AdminForumList />
          ) : (
            <ForumList />
          )}
        </div>
      </div>
      {/* Bottom Navigation Bar - Visible only on mobile */}
      <BottomNavigationBar 
        onHomeClick={handleHomeClick}
        onLoginClick={handleLoginClick}
        onSignupClick={handleSignupClick}
        onProfileClick={handleProfileClick}
        onAccountSettingsClick={handleAccountSettingsClick}
        onJobsClick={handleJobsClick}
        onMessagesClick={handleMessagesClick}
        onForumClick={handleForumClick}
      />
    </div>
  );
};

export default ForumPage;
